export const enum FailedPaymentResolutionType {
  /** Means the payment failure can be resolved by the user alone, using the web page or the app */
  selfServe = 'SELF_SERVE',
  /** Means the payment failure can only be resolved by calling customer care */
  callCustomerCare = 'CALL_CUSTOMER_CARE',
}
